import { ca } from '@cian/analytics';
import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { isFromBuilder, isOfficialSeller } from '../../utils/agent';

export function trackGoToCard(cardType: string, label: string) {
  ca('event', {
    action: `to_${cardType}_floating_block`,
    category: 'card',
    label: `to_${cardType}_${label}`,
    name: 'oldevent',
  });
}

export function getCardType(offer: IOfferSchema) {
  if (isOfficialSeller(offer) || isFromBuilder(offer)) {
    return 'developerCard';
  }

  return 'realtorCard';
}
